;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"62e76f90-gatoradeteamzone-frontend"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryNextJsVersion"] = "15.4.10";globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";globalThis["_sentryAssetPrefix"] = "";globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";import * as Sentry from "@sentry/nextjs";
import {
  sentryDenyUrlsList,
  sentryIgnoreErrorsList,
} from "@pepdirect/v3/constants";
import {
  environment,
  isProductionReady,
  sentryDSN,
  sentryEnvironment,
} from "config";

const releaseId = process.env.SENTRY_RELEASE;

Sentry.init({
  enabled: isProductionReady,
  dsn: sentryDSN || "",
  environment: sentryEnvironment || environment,
  release: releaseId,
  allowUrls: [
    /https?:\/\/assets\.?production\.decovostatic\.com/,
    /https?:\/\/assets\.?staging\.decovostatic\.com/,
  ],
  // https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/filtering/
  ignoreErrors: sentryIgnoreErrorsList,
  denyUrls: sentryDenyUrlsList,
  beforeSend(event, hint) {
    try {
      const frames = event?.exception?.values?.[0]?.stacktrace?.frames || [];
      if (frames?.length) {
        // Check if the error is from a denied URL
        const filename = frames[0]?.filename || "";
        if (sentryDenyUrlsList.some((pattern) => pattern.test(filename))) {
          return null;
        }

        // Check existing exclusions
        const excludedFilenames = [`<anonymous>`, `/gtm.js`];
        const excludedFilenameAtIndex = (i: number) =>
          excludedFilenames.includes(frames?.[i]?.filename || "");

        if (excludedFilenameAtIndex(0)) return null;

        // catches excludedFilenames from injected anonymous
        // gtm script matching this common sentry error pattern
        if (frames.length === 2 && excludedFilenameAtIndex(1)) return null;
      }
      // eslint-disable-next-line no-empty
    } catch (e) {}

    return event;
  },
  integrations: [
    // https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/filtering/#using-thirdpartyerrorfilterintegration
    Sentry.thirdPartyErrorFilterIntegration({
      filterKeys: ["sentry-pepdirect"],
      behaviour: "drop-error-if-exclusively-contains-third-party-frames",
    }),
  ],
});

Sentry.getCurrentScope().setLevel("error");
